import { appRoutes } from '@/constants/routes';

import { useStripeRedirect } from './use-stripe-redirect';

/** Opens the Stripe portal, which returns to `returnPath`. */
export const useOpenPortal = (returnPath: string = appRoutes.settingsBilling) => {
  const { redirect, pending } = useStripeRedirect({ errorTitle: 'Billing could not be opened. Try again.' });
  const openPortal = () =>
    redirect('portal', (api) => api.createPortalSession({ returnUrl: `${window.location.origin}${returnPath}` }));

  return { openPortal, opening: pending !== undefined };
};
